import { render, staticRenderFns } from "./ProgramAccesses.vue?vue&type=template&id=260052c2&"
import script from "./ProgramAccesses.vue?vue&type=script&lang=js&"
export * from "./ProgramAccesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports